import React from "react";

import "./restart.scss";
import InlineFeedback from "../inlinefeedback/inlinefeedback";


const Restart = (props:any) => {

  return <div className="restart-container">

    <button 
      className="show-more-link restart top-arrow-button" 
      onClick={props.startfromtop}
      title="Start from top"
      aria-label="Start from top"
      data-tooltip="Start from top"
    >
    </button>

    <InlineFeedback conversationId={props.conversationId} />

  </div>;
};
export default Restart;